import DialogHandler from '../app/components/DialogHandler';

export default class StampDialogHandler {
    static #instance: StampDialogHandler | null = null;

    readonly #dialogToggleButtons: HTMLElement[] = [];

    public constructor() {
        this.#dialogToggleButtons = Array.from(
            document.querySelectorAll('[data-role="stamp-dialog-toggle"]')
        );

        for (const button of this.#dialogToggleButtons) {
            const dialogId = button.getAttribute('data-dialog-id');
            const stampDialogManager = new DialogHandler({
                buttonSelector: `[data-dialog-id="${dialogId}"]`,
                dialogSelector: `[data-role="${dialogId}"]`
            });
            stampDialogManager.initialize();
        }
    }

    public static getInstance(): StampDialogHandler {
        if (!StampDialogHandler.#instance) {
            StampDialogHandler.#instance = new StampDialogHandler();
        }
        return StampDialogHandler.#instance;
    }
}
